<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item, index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control == "Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control == "File"' :data-val="item"></File>
			<Table v-if='item.Property.Control == "Table"' @child-event='tableOperation' :data-val='item'
				:template-data='templateData'></Table>
			<Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control == "Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading"
			size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import Choose from '../components/Choose.vue';
import wx from 'weixin-js-sdk'
import stringUtils from "../assets/js/stringUtil.js";
import {
	initWxConfig
} from '../api/jssdk.js';
import {
	getTemplateInfo,
	submitProcess,
	sendMessage,
	AllowApplyForVerify
} from '@/api/approval'
import {
	getRelation
} from '@/api/employee'
import { getOptionValForDataVal } from '../utils/componentUtils'

var isSubmit = false;

var template = {
	TemplateContent: {
		Controls: []
	}
};
const sendMessagetTemplate = {
	title: null,
	url: null,
	toUser: [],
	desc: null,
	template: null,
};
export default {
	components: {
		Contact,
		Dates,
		Version,
		Money,
		Tips,
		File,
		Table,
		Digit,
		Selector,
		Textarea,
		Choose
	},
	data() {
		return {
			templateData: template,
			relationList: null,
			logInfo: null,
			templateId: "",
			spNo: null,
			flowId: null,
			formLoading: false,
			listLoading: false,
			sendMessageData: Object.assign({}, sendMessagetTemplate),
			isDisabled: false
		}
	},
	created() {
		initWxConfig(this);
		this.logInfo = this.getLoginUserInfo();
		this.templateId = this.$route.query.templateId;
		this.spNo = this.$route.query.spNo;
		this.flowId = this.$route.query.flowId;
		this.getTemplate();
		stringUtils.setAddIsShow(true);
	},
	methods: { //方法

		clickChoose(dataVal, name) {
			window.wx.invoke("selectEnterpriseContact", {
				"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
				"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
			}, function (res) {
				if (res.err_msg == "selectEnterpriseContact:ok") {
					if (typeof res.result == 'string') {
						res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
					}
					var depart = res.result.departmentList[0]; // 已选的部门列表
					dataVal.Values = [];
					dataVal.Values.push([depart.id, depart.name]);
					dataVal.Value = depart.name;
				}
			})
		},

		getTemplate: async function () {
			this.listLoading = true;
			var title = this.logInfo.fullName;
			var jobLevel = this.logInfo.JobLevel;
			var departs = this.logInfo.fullName.split("/");
			// if(departs.indexOf("二级市场营运中心")==-1&&departs.indexOf("代理")==-1){
			// 	this.Message({
			// 		message: '没有申请权限',
			// 		type: 'error',
			// 		duration: 1000
			// 	});
			// 	this.isDisabled = true;
			// }
			await getTemplateInfo(this.templateId).then(async response => {
				var controls = response.Body;
				await this.getEmployeeRelation();
				controls.TemplateContent.Controls.forEach((item) => {
					if (item.Property.Title[0].Text == "营运部门总经理") {
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "人员") {
						item.Values = [[this.logInfo.EmpNo, this.logInfo.EmpName]];
					}
					if (item.Property.Title[0].Text == "是否总经理审批") {
						item.IsShow = true;
					}
					if (item.Property.Title[0].Text === "是否抄送给财务") {
						item.IsShow = true;
						item.Property.Require = 0;
					}
					if (item.Property.Title[0].Text === "合同中是否有约定返还" || item.Property.Title[0].Text === "实际操作中是否有返还") {
						item.IsShow = false
					}
				});
				this.templateData = this.assignControl(controls, this.logInfo);
				this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
				this.listLoading = false;
			});

		},
		getEmployeeRelation: async function () {
			await getRelation(this.logInfo.EmpNo).then(response => {
				this.relationList = response.Body[0].Nodes;
			});
		},
		getTextVal() { },
		getSelectorVal(val, name) {
			var controls = this.templateData.TemplateContent.Controls;
			var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
			if (name == "选择营运部门总经理审批") {
				var text = controlInfo.Config.Selector.Options
					.filter(item => {
						return val.indexOf(item.Key) > -1;
					})[0].Value[0].Text;
				var control = controls.filter(item => item.Property.Title[0].Text == "营运部门总经理")[0];
				if (text == "秦文") {
					control.Values = [["SC24000028", "秦文"]]
				}
				if (text == "程科") {
					control.Values = [["SC24000025", "程科"]]
				}
				if (text == "董强") {
					control.Values = [["SC24000026", "董强"]]
				}
				if (text == "吴江") {
					control.Values = [["SC24000023", "吴江"]]
				}
				if (text == "唐媛") {
					control.Values = [["SC24000024", "唐媛"]]
				}
				if (text == "赵海亮") {
					control.Values = [["SC24000030", "赵海亮"]]
				}
				if (text == "陈相云") {
					control.Values = [["SC23000441", "陈相云"]]
				}
			} else if (name === "申请事宜") {
				const optionVal = getOptionValForDataVal(val, controlInfo);
				// 拿到合同中是否有约定返还这个单选框
				let isYdControl = controls.filter(e => e.Property.Title[0].Text === "合同中是否有约定返还")[0];
				// 如果选择的策划上树
				if (optionVal !== "策划上数") {
					isYdControl.IsShow = false;
					isYdControl.Property.Require = 0;
					return;
				}
				isYdControl.IsShow = true;
				isYdControl.Property.Require = 1;
			} else if (name === "合同中是否有约定返还") {
				const optionVal = getOptionValForDataVal(val, controlInfo);
				// 拿到合同中实际操作中是否有返还这个单选框
				let isYdControl = controls.filter(e => e.Property.Title[0].Text === "实际操作中是否有返还")[0];
				isYdControl.IsShow = true;
				isYdControl.Property.Require = 1;
				if (optionVal === "否") {
					isYdControl.IsShow = false;
					isYdControl.Property.Require = 0;
					return;
				}
				isYdControl.IsShow = true;
				isYdControl.Property.Require = 1;
			}
		},
		tableOperation(val, type, datas) {
			if (type == 'compute') {
				return;
			}
			this.tableoperation(val, type, datas, this);
		},
		submit() {
			//数据校验
			if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
				return;
			}

			var SummaryList = [];
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			var control = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "选择所在部门" })[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			var NameOfData = "";
			for (var i = 0; i < control.Config.Selector.Options.length; i++) {
				var data = control.Config.Selector.Options[i];
				if (data.Key == control.Value) {
					NameOfData = data.Value[0].Text;
				}
			}
			info.SummaryInfo.push({ "Text": "选择所在部门：" + NameOfData, "Lang": "zh_CN" });
			SummaryList.push(info);

			var control3 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "项目名称" })[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "项目名称：" + control3.Value, "Lang": "zh_CN" });
			SummaryList.push(info);

			var control2 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "申请事宜" })[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			var NameOfData = "";
			for (var i = 0; i < control2.Config.Selector.Options.length; i++) {
				var data = control2.Config.Selector.Options[i];
				if (data.Key == control2.Value) {
					NameOfData = data.Value[0].Text;
				}
			}
			info.SummaryInfo.push({ "Text": "申请事宜：" + NameOfData, "Lang": "zh_CN" });
			SummaryList.push(info);

			this.templateData.SummaryList = SummaryList

			if (isSubmit) {
				this.Message({
					message: '已提交',
					type: 'warning',
					duration: 1000
				});
				return;
			}
			isSubmit = true;
			this.listLoading = true;
			this.sendMessageData.template = this.templateData;
			this.sendMessageData.title = "审批";

			//SC12050030 
			//SC16005075
			//SC17001763
			//SC18002633
			this.sendMessageData.toUser = ["SC12050030", "SC16005075", "SC17001763"];
			// this.sendMessageData.toUser=["SC20003197","SC18003883"];
			this.sendMessageData.desc = "申请人：" + this.logInfo.EmpName;
			this.sendMessageData.url = document.location.hostname + "/specialSituationReportCheck?templateId=3TmBHXKPMBbiB4AjU5APW8Wroni1dVap2bi1KXaP&empNo=" + this.logInfo.EmpNo;

			//提交 发信息
			// sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData,1,this.logInfo.EmpName).then(response => {
			// 	this.Message({
			// 		message: '申请成功',
			// 		type: 'success',
			// 		duration: 3 * 1000
			// 	});
			// 	setTimeout(() => {
			// 		this.$router.push("/index");
			// 	}, 3000)
			// }).finally(() => {
			// 	isSubmit = false;
			// 	this.listLoading = false;
			// });
			submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData, this.flowId).then(response => {
				this.Message({
					message: '申请成功',
					type: 'success',
					duration: 3 * 1000
				});
				setTimeout(() => {
					this.$router.push("/index");
				}, 3000)
			}).finally(() => {
				isSubmit = false;
				this.listLoading = false;
			});

		}
	}

}
</script>

<style scoped lang="less">
.pages {
	padding-bottom: 14px;
}
</style>
